if (!customElements.get("parallax-section")) {
  customElements.define(
    "parallax-section",
    class Parallax extends HTMLElement {
      constructor() {
        super();
        this.images = this.querySelectorAll(".wt-parallax__img");
        this.scrollHandler = null;
        this.isInitialized = false;
      }

      connectedCallback() {
        this.init();
      }

      disconnectedCallback() {
        this.cleanup();
      }

      decorateImages() {
        try {
          const listItems = this.querySelectorAll(".wt-parallax__gallery__item");
          listItems.forEach((item, index) => {
            const image = item.querySelector(".wt-parallax__img");
            if (image) {
              image.classList.add(
                `wt-parallax__img--${index % 2 === 0 ? "odd" : "even"}`,
              );
            }
          });
        } catch (error) {
          console.warn('Parallax: Error decorating images:', error);
        }
      }

      rotateOnScroll() {
        const { images } = this;
        const maxRotation = parseInt(this.dataset.rotation, 10) || 5;

        if (images.length === 0) {
          console.warn('Parallax: No images found for rotation effect');
          return;
        }

        this.scrollHandler = () => {
          try {
            images.forEach((image) => {
              if (!image || !image.isConnected) return;
              
              const imageRect = image.getBoundingClientRect();
              const windowHeight = window.innerHeight;

              if (imageRect.top < windowHeight && imageRect.bottom > 0) {
                let visiblePart = windowHeight - imageRect.top;
                let visiblePercent = Math.max(0, Math.min(100, (visiblePart / windowHeight) * 100));
                let rotationDegree = Math.min(
                  (visiblePercent / 100) * maxRotation,
                  maxRotation,
                );

                if (image.classList.contains("wt-parallax__img--odd")) {
                  rotationDegree *= -1;
                }

                window.requestAnimationFrame(() => {
                  if (image.isConnected) {
                    image.style.transform = `translate3d(0px, 0px, 0px) rotate(${rotationDegree}deg)`;
                  }
                });
              }
            });
          } catch (error) {
            console.warn('Parallax: Error in scroll handler:', error);
          }
        };

        // Use passive listener for better performance
        document.addEventListener("scroll", this.scrollHandler, { passive: true });
      }

      cleanup() {
        if (this.scrollHandler) {
          document.removeEventListener("scroll", this.scrollHandler);
          this.scrollHandler = null;
        }
      }

      init() {
        if (this.isInitialized) return;
        
        try {
          this.decorateImages();
          this.rotateOnScroll();
          this.isInitialized = true;
        } catch (error) {
          console.error('Parallax: Initialization failed:', error);
        }
      }
    },
  );
}
